export enum InANutshellAvailability {
  AVAILABLE = 'available',
  NOT_AVAILABLE = 'not available',
}
